import { useState, useEffect, useRef, useCallback } from 'react';
import LoginFrame from 'layout/login-frame';
import styles from './index.module.sass';
import Button from 'componets/button';
import { NOTIFICATION_TRANSFER_URL } from 'config/config';
import { useHistory } from 'react-router-dom';
import TransferInformation from 'modules/transfer-information';
import useDevice, { DEVICE_MOBILE } from 'hooks/use-device';
import {
  CHANGE_CARD_NUMBER,
  CHANGE_CARD_EXPIRED_DATE,
  CHANGE_CARD_CVC,
  SET_ACTIVATION_STEP,
  useLoginContext,
} from './use-login';
import BindCard from 'modules/bind-card';
import classnames from 'classnames/bind';
import analytics from 'service/analytics';
import { PATH } from 'config/path';
const cx = classnames.bind(styles);

const ActivationForm = () => {
  const { state, dispatch, onCompleteBindCard, onLockTab, onUnlockTab } = useLoginContext();
  const device = useDevice();
  const history = useHistory();
  const [frameHeight, setFrameHeight] = useState(0);
  const isStoredValueService = state.activationStep === 'stored-value-service';
  const storedValueServiceRef = useRef();
  const bindCardServiceRef = useRef();

  useEffect(() => {
    if (isStoredValueService) {
      setFrameHeight(storedValueServiceRef.current.scrollHeight);
    } else {
      setFrameHeight(bindCardServiceRef.current.scrollHeight);
    }
  }, [
    isStoredValueService,
    state.cardNumberErrorMessage,
    state.cardExpiredDateErrorMessage,
    state.cardCVCErrorMessage,
  ]);

  const onNotification = () => {
    analytics.track('登入頁_首次登入_付款資訊_通知已轉帳_click');
    window.open(NOTIFICATION_TRANSFER_URL);
  };

  const onGoToAdmin = () => {
    analytics.track('登入頁_首次登入_付款資訊_繼續前往後台_click');
    history.push(PATH.PROFILE);
  };

  const onCopy = () => analytics.track('登入頁_首次登入_付款資訊_複製_click');

  // const onBindCardService = useCallback(() => {
  //   dispatch({ type: SET_ACTIVATION_STEP, payload: 'bind-card-service' });
  // }, [dispatch]);

  const onChangeCardNumber = useCallback(
    value => {
      dispatch({ type: CHANGE_CARD_NUMBER, payload: value });
    },
    [dispatch]
  );

  const onChangeCardExpiredDate = useCallback(
    value => {
      dispatch({ type: CHANGE_CARD_EXPIRED_DATE, payload: value });
    },
    [dispatch]
  );

  const onChangeCardCVC = useCallback(
    value => {
      dispatch({ type: CHANGE_CARD_CVC, payload: value });
    },
    [dispatch]
  );

  const onBack = useCallback(() => {
    dispatch({ type: SET_ACTIVATION_STEP, payload: 'stored-value-service' });
  }, [dispatch]);

  const indent = device === DEVICE_MOBILE ? -20 : -40;

  const StoredValueService = () => {
    const storedValueServiceClass = cx({
      'stored-value-service': true,
      out: !isStoredValueService,
    });

    return (
      <div className={storedValueServiceClass} ref={storedValueServiceRef}>
        <TransferInformation title="完成儲值開通服務" indent={indent} onCopy={onCopy} />
        <Button theme="black" size="full-width" className={styles['button']} onClick={onNotification}>
          通知已轉帳
        </Button>
      </div>
    );
  };

  const BindCardService = () => {
    const bindCardServiceClass = cx({
      'bind-card-service': true,
      in: !isStoredValueService,
    });

    return (
      <div className={bindCardServiceClass} ref={bindCardServiceRef}>
        <div className={styles.title}>綁定信用卡付款</div>
        <div
          className={styles.alert}
          style={{ marginLeft: indent, marginRight: indent, paddingLeft: -indent, paddingRight: -indent }}
        >
          提醒您：使用信用卡將無法享儲值方式較高額的回饋。
        </div>
        <BindCard
          cardNumber={state.cardNumber}
          cardNumberErrorMessage={state.cardNumberErrorMessage}
          onChangeCardNumber={onChangeCardNumber}
          cardExpiredDate={state.cardExpiredDate}
          cardExpiredDateErrorMessage={state.cardExpiredDateErrorMessage}
          onChangeCardExpiredDate={onChangeCardExpiredDate}
          cardCVC={state.cardCVC}
          cardCVCErrorMessage={state.cardCVCErrorMessage}
          onChangeCardCVC={onChangeCardCVC}
          onFocus={onUnlockTab}
          onLastFocus={onLockTab}
          onSend={onCompleteBindCard}
        />
        <div className={styles.buttons}>
          <Button variant="text" onClick={onBack}>
            返回儲值
          </Button>
          <Button size="large" onClick={onCompleteBindCard}>
            完成綁定
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <LoginFrame>
        <div className={styles['sub-title']}>就快完成了</div>
        <div className={styles.container} style={{ height: frameHeight }}>
          <div className={styles['group']}>
            {StoredValueService()}
            {BindCardService()}
          </div>
        </div>
      </LoginFrame>
      <div className={styles['other']}>
        <Button theme="blue" size="large" className={styles['button-register']} onClick={onGoToAdmin}>
          繼續前往後台
        </Button>
      </div>
    </>
  );
};

export default ActivationForm;
